module.exports = __webpack_public_path__ + "static/TheBlu-Encounter-bb22f1d45ce97653a8cf37d69bb835f0.jpg";